import { history } from 'common/services/history';
import addInvoiceUseCase from 'invoices/services/addInvoiceUseCase';
import updateInvoiceDetailUseCase from 'invoices/services/detail/updateInvoiceDetailUseCase';
import { updateReac2 } from 'actions/reacondicionadosActions';

const addInvoiceFromReacUseCase = async (items) => {
    const list = Array.isArray(items) ? items : [items];

    const concept = list.map(item =>
        `${item.modelo || 'Dispositivo'} ${item.capacidad || ''} ${item.color || ''}`.trim()
    ).join(', ');

    const invoice = {
        concept,
        taskReference: list.map(i => i.reference).filter(Boolean).join(', '),
        paymentMode: 2,
    };

    const data = list.map(item => ({
        reference: item.reference || '',
        description: `${item.modelo || 'Dispositivo'} ${item.capacidad || ''} ${item.color || ''}`.trim(),
        unitPrice: item.precio || 0,
        units: 1,
        iva: true,
    }));

    const idInvoice = await addInvoiceUseCase(invoice);
    await updateInvoiceDetailUseCase({ ...invoice, id: idInvoice }, null, { data });

    const fechaVenta = new Date().getTime();
    await Promise.all(list.map(item => updateReac2({ ...item, estado: 'vendido', vendido: true, fechaVenta: item.fechaVenta || fechaVenta })));

    history.push(`/invoices?id=${idInvoice}`);
};

export default addInvoiceFromReacUseCase;
